module.exports = {
  siteMetadata: {
    title: 'Curveball',
  },
  plugins: [
  `gatsby-plugin-sass`,
  'gatsby-plugin-react-helmet',
  `gatsby-transformer-json`,
  {
    resolve: `gatsby-source-filesystem`,
    options: {
      path: `./src/data/`,
    },
  },
  {
    resolve: 'gatsby-plugin-mailchimp',
    options: {
      endpoint: 'https://curveball.us18.list-manage.com/subscribe/post?u=7d1ea90d9ced77bd2fef87ce5&amp;id=129288859c',
    }
  },
  {
      resolve: `gatsby-plugin-google-analytics`,
      options: {
        trackingId: "UA-90346380-2",
        // Puts tracking script in the head instead of the body
        head: true,
        // Setting this parameter is optional
        anonymize: false,
        // Setting this parameter is also optional
        respectDNT: false,
        // Avoids sending pageview hits from custom paths
        exclude: [],
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./gatsby-config.js